import { render, staticRenderFns } from "./DisplayErrors.vue?vue&type=template&id=1f880112"
import script from "./DisplayErrors.vue?vue&type=script&lang=ts"
export * from "./DisplayErrors.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports